import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#40ae75',
        secondary: '#697d8a',
        accent: '#393D3F',
        white: '#FDFDFF',
        error: '#F05D5E',
      },
    },
  },
});
